"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TitleWithUnderLine = require("./TitleWithUnderLine");

var _TitleWithUnderLine2 = _interopRequireDefault(_TitleWithUnderLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TitleWithUnderLine2.default;